import {
  Avatar,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemAvatar,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material'
import dayjs from 'dayjs'
import { FC } from 'react'
import { UserService } from '../services/user'
import { themeMeta } from '../theme/meta'
import { Fa } from './Fa'

const SessionSummary: FC<SessionSummaryProps> = ({
  session,
  name = true,
  wrapped = false,
}) => {
  const content = (
    <>
      {name && (
        <Typography variant="h3" mb={1}>
          {session.gym_category.category.name}
        </Typography>
      )}
      <List
        dense
        disablePadding
        sx={{
          '& .MuiListItem-root': {
            gap: 1,
          },
          '& .MuiListItemIcon-root, & .MuiListItemAvatar-root': {
            minWidth: 0,
          },
        }}
      >
        <ListItem disableGutters>
          <ListItemIcon>
            <Fa name="clock" size="md" color="secondary" />
          </ListItemIcon>
          <ListItemText
            primary={[
              dayjs(session.session_start_time_utc)
                .tz()
                .format('YYYY-MM-DD HH:mm'),
              dayjs(session.session_end_time_utc).tz().format('HH:mm'),
            ].join(' ~ ')}
          />
        </ListItem>
        <ListItem disableGutters>
          <ListItemAvatar>
            <Avatar
              src={session.gym_staff.user.profile_picture}
              sx={{ fontSize: '1em', width: '1em', height: '1em' }}
            ></Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={UserService.getFullName(session.gym_staff.user)}
          />
        </ListItem>
        <ListItem disableGutters>
          <ListItemIcon>
            <Fa name="location-dot" size="md" color="secondary" />
          </ListItemIcon>
          <ListItemText primary={session.gym_room?.name || '-'} />
        </ListItem>
      </List>
    </>
  )

  if (wrapped) {
    return (
      <Card sx={{ bgcolor: themeMeta.colors.monochrome.bg }}>
        <CardContent>{content}</CardContent>
      </Card>
    )
  }

  return content
}

type SessionSummaryProps = {
  session: Dto.Session
  name?: boolean
  wrapped?: boolean
}

export { SessionSummary }
export type { SessionSummaryProps }
